const KEY = 'kingspark_waitstaff_install_hint_dismissed';

export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  if (nav.standalone === true) return true;
  return window.matchMedia('(display-mode: standalone)').matches;
}

export function isWaitstaffInstallHintDismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissWaitstaffInstallHint() {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // ignore
  }
}

export function waitstaffInstallHintCopy(): { title: string; body: string } {
  const isIos = typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (isIos) {
    return {
      title: 'Add to Home Screen',
      body: 'Tap Share, then Add to Home Screen. Next time open Kings Park from the icon — no browser address bar.',
    };
  }
  return {
    title: 'Install this app',
    body: 'Use your browser menu → Add to Home Screen / Install app. Then open Kings Park from the icon like a native app.',
  };
}
